import { render, staticRenderFns } from "./benefit-table.vue?vue&type=template&id=218c9520&scoped=true&"
import script from "./benefit-table.vue?vue&type=script&lang=js&"
export * from "./benefit-table.vue?vue&type=script&lang=js&"
import style0 from "./benefit-table.vue?vue&type=style&index=0&id=218c9520&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218c9520",
  null
  
)

export default component.exports